import { TableRow, TableCell } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';

export function StockTableLoading() {
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <TableRow key={i} className="border-b border-slate-100 hover:bg-transparent">
          {/* Variant Column */}
          <TableCell className="py-4 px-4">
            <div className="flex items-center space-x-3">
              <Skeleton className="h-10 w-10 rounded-full shrink-0" />
              <div className="space-y-1.5 flex-1 min-w-0">
                <Skeleton className="h-4 w-32 rounded" />
                <Skeleton className="h-3.5 w-20 rounded" />
              </div>
            </div>
          </TableCell>

          {/* Stock Movement Column */}
          <TableCell className="py-4 px-4">
            <div className="space-y-2 max-w-[150px] mx-auto">
              <Skeleton className="h-4 w-28 rounded mx-auto" />
              <Skeleton className="h-3.5 w-16 rounded mx-auto" />
            </div>
          </TableCell>

          {/* Price Column */}
          <TableCell className="py-4 px-4 text-right">
            <Skeleton className="h-4 w-12 rounded ml-auto" />
          </TableCell>

          {/* Date Column */}
          <TableCell className="py-4 px-4 text-center">
            <Skeleton className="h-4 w-24 rounded mx-auto" />
          </TableCell>

          {/* Action Column */}
          <TableCell className="py-4 px-4 text-center w-12">
            <Skeleton className="h-8 w-8 rounded-full mx-auto" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
